import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
    en: {
        label: {
            results_for: "Results for",
            article: "Article",
            image: "Image",
            searching_articles: "Searching articles ...",
            no_articles_found: "No articles found",
            no_user_input: "Please enter some information",
            description: "Description",
            select_category_filter: "--- Filter for category ---",
            loading_categories: "Loading categories ...",
            download_pdf: "Download PDF",
            pdf: "PDF",
            close: "Close",
            version: "Version",
        },
    },
    de: {
        label: {
            results_for: "Ergebnisse für",
            article: "Artikel",
            image: "Bild",
            searching_articles: "Artikel werden gesucht ...",
            no_articles_found: "Keine Artikel gefunden",
            no_user_input: "Bitte gib deinen Suchbegriff ein",
            description: "Beschreibung",
            select_category_filter: "--- Nach Kategorien filtern ---",
            loading_categories: "Kategorien werden geladen ...",
            download_pdf: "PDF herunterladen",
            pdf: "PDF",
            close: "Schließen",
            version: "Version",
        },
    },
};

const dateTimeFormats = {
    en: {
        time: {
            hour: "numeric",
            minute: "numeric",
        },
        shortDay: {
            weekday: "long",
            day: "2-digit",
            month: "long",
        },
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "short",
            day: "numeric",
            weekday: "short",
            hour: "numeric",
            minute: "numeric",
        },
    },
    de: {
        time: {
            hour: "numeric",
            minute: "numeric",
        },
        shortDay: {
            weekday: "long",
            day: "2-digit",
            month: "long",
        },
        short: {
            year: "numeric",
            month: "short",
            day: "numeric",
        },
        long: {
            year: "numeric",
            month: "short",
            day: "numeric",
            weekday: "short",
            hour: "numeric",
            minute: "numeric",
        },
    },
};

const i18n = new VueI18n({
    locale: "en",
    fallbackLocale: "en",
    messages,
    dateTimeFormats,
});

export default i18n;
